import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import FirmwareFileFlashCard from './FirmwareFileFlashCard';
import FirmwareVersionFlashCard from './FirmwareVersionFlashCard';

// ---------------------------------------------------------------------------

export default function FirmwareTab({
  deviceInfo,
  onFlashFile,
  onFlashVersion,
  availableVersions = [],
  versionsLoading = false,
  isAdmin,
  connected,
  latestFirmwareVersion,
  onOpenWizard,
}) {
  const hasUpdate =
    latestFirmwareVersion &&
    deviceInfo?.firmware &&
    latestFirmwareVersion !== deviceInfo.firmware;

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Firmware Update
      </Typography>

      {hasUpdate && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Alert severity="info" sx={{ mb: 2 }}>
              A new firmware version is available.
            </Alert>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Current: <strong>v{deviceInfo.firmware}</strong> &rarr; Latest:{' '}
              <strong>v{latestFirmwareVersion}</strong>
            </Typography>
            <Button
              variant="contained"
              size="large"
              startIcon={<SystemUpdateAltIcon />}
              onClick={onOpenWizard}
              disabled={!connected}
            >
              Update firmware
            </Button>
          </CardContent>
        </Card>
      )}

      {!hasUpdate && deviceInfo?.firmware && (
        <Alert severity="success" sx={{ mb: 3 }}>
          Your sensor is running the latest firmware (v{deviceInfo.firmware}).
        </Alert>
      )}

      {isAdmin && onFlashVersion && (
        <FirmwareVersionFlashCard
          versions={availableVersions}
          onFlashVersion={onFlashVersion}
          disabled={!connected}
          loading={versionsLoading}
        />
      )}

      {isAdmin && onFlashFile && (
        <FirmwareFileFlashCard onFlashFile={onFlashFile} disabled={!connected} />
      )}
    </>
  );
}

FirmwareTab.propTypes = {
  deviceInfo: PropTypes.object,
  onFlashFile: PropTypes.func,
  onFlashVersion: PropTypes.func,
  availableVersions: PropTypes.array,
  versionsLoading: PropTypes.bool,
  isAdmin: PropTypes.bool,
  connected: PropTypes.bool.isRequired,
  latestFirmwareVersion: PropTypes.string,
  onOpenWizard: PropTypes.func.isRequired,
};
